export default __webpack_public_path__ + "static/media/bg.f06ca688.svg";